// extracted by mini-css-extract-plugin
export default {"returnbody":"ReturnRefund_returnbody__wgqDq","container1":"ReturnRefund_container1__-8hFX","head":"ReturnRefund_head__x3wG2","autonix":"ReturnRefund_autonix__NgiSU"};